<!-- <div class="container-fluid pt68">
	<app-dashboard-side-nav (changeSidemenu)="sideMenuChange($event)"></app-dashboard-side-nav>
</div> -->
<!-- <router-outlet></router-outlet> -->

<app-header *ngIf="comm.head"></app-header>

<router-outlet></router-outlet>